// radius.ts
export const radiusTokens = {
  "radius": {
    "xs": {
      "value": "4px",
      "type": "borderRadius",
      "filePath": "design-tokens/radius.json",
      "isSource": true,
      "original": {
        "value": "4px",
        "type": "borderRadius"
      },
      "name": "RadiusXs",
      "attributes": {
        "category": "radius",
        "type": "xs"
      },
      "path": [
        "radius",
        "xs"
      ]
    },
    "sm": {
      "value": "8px",
      "type": "borderRadius",
      "filePath": "design-tokens/radius.json",
      "isSource": true,
      "original": {
        "value": "8px",
        "type": "borderRadius"
      },
      "name": "RadiusSm",
      "attributes": {
        "category": "radius",
        "type": "sm"
      },
      "path": [
        "radius",
        "sm"
      ]
    },
    "md": {
      "value": "12px",
      "type": "borderRadius",
      "filePath": "design-tokens/radius.json",
      "isSource": true,
      "original": {
        "value": "12px",
        "type": "borderRadius"
      },
      "name": "RadiusMd",
      "attributes": {
        "category": "radius",
        "type": "md"
      },
      "path": [
        "radius",
        "md"
      ]
    },
    "lg": {
      "value": "16px",
      "type": "borderRadius",
      "filePath": "design-tokens/radius.json",
      "isSource": true,
      "original": {
        "value": "16px",
        "type": "borderRadius"
      },
      "name": "RadiusLg",
      "attributes": {
        "category": "radius",
        "type": "lg"
      },
      "path": [
        "radius",
        "lg"
      ]
    },
    "xl": {
      "value": "24px",
      "type": "borderRadius",
      "filePath": "design-tokens/radius.json",
      "isSource": true,
      "original": {
        "value": "24px",
        "type": "borderRadius"
      },
      "name": "RadiusXl",
      "attributes": {
        "category": "radius",
        "type": "xl"
      },
      "path": [
        "radius",
        "xl"
      ]
    },
    "pill": {
      "value": "999px",
      "type": "borderRadius",
      "filePath": "design-tokens/radius.json",
      "isSource": true,
      "original": {
        "value": "999px",
        "type": "borderRadius"
      },
      "name": "RadiusPill",
      "attributes": {
        "category": "radius",
        "type": "pill"
      },
      "path": [
        "radius",
        "pill"
      ]
    }
  }
} as const;

export type RadiusTokens = typeof radiusTokens;
